import { FC, useEffect } from 'react';
import { useDispatch } from '@cbridge-utils/react-redux';
import { SpreadProfileAction } from '../spreadProfile.action';

export const SpreadProfileListSubscriber: FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(SpreadProfileAction.loadList.started());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(SpreadProfileAction.destroy());
    };
  }, [dispatch]);

  return null;
};
